//  An object is made of elements
export const variants = ["0", "1", "2", "4", "5", "6", "7", "8", "9"] as const;
export type Variant = (typeof variants)[number];
export const coordinates = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29,
] as const;
export type Coordinate = (typeof coordinates)[number];

export class _Element {
  a!: Coordinate;
  b!: Coordinate;
  variant!: Variant;

  constructor(self: _Element) {
    Object.assign(this, self);
  }
}

export class _Object {
  elements: _Element[];
  constructor(elements: _Element[]) {
    this.elements = elements;
  }
  toGrid() {
    // missing elements are represented as undefined
    const minA = Math.min(...this.elements.map((e) => e.a));
    const minB = Math.min(...this.elements.map((e) => e.b));
    const maxA = Math.max(...this.elements.map((e) => e.a));
    const maxB = Math.max(...this.elements.map((e) => e.b));
    const grid: (number | undefined)[][] = [];
    for (let a = minA; a <= maxA; a++) {
      grid[a] = [];
      for (let b = minB; b <= maxB; b++) {
        const element = this.elements.find((e) => e.a === a && e.b === b);
        grid[a][b] = element ? parseInt(element.variant) : undefined;
      }
    }
    return grid;
  }
  toString() {
    return this.toGrid()
      .map((row) => row.map((e) => (e === undefined ? "•" : e)).join(""))
      .join("\n");
  }
}
